module.exports = __webpack_public_path__ + "static/media/293581.6d48977a.png";